import React, { useState } from 'react';
import './Service.css';
import customIcon from '../../assets/logos/custom-icon.webp';
import mobileIcon from '../../assets/logos/mobile-app.webp';
import websiteIcon from '../../assets/logos/website.webp';

const Service = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <section className="service-section" id="services">
      <div className="service-header">
        <h2 className="service-title">
          <span className="title-gradient">Innovating Software Solutions</span>
          <span className="title-sub">for a Digital World</span>
        </h2>
        <p className="service-subtext">
          At Skript, we provide cutting-edge software solutions, mobile apps, and website
          development services to help your business thrive in the digital age.
        </p>
      </div>

      <div className="service-cards">
        <div 
          className={`service-card ${hoveredCard === 0 ? 'hovered' : ''}`}
          onMouseEnter={() => setHoveredCard(0)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div className="card-bg"></div>
          <div className="card-content">
            <div className="card-icon">
            <img src={customIcon} alt="Custom Software" className="service-icon" />
            </div>
            <h3>Custom Software Development</h3>
            <p>
              From concept to deployment, we build custom software solutions that streamline
              operations and drive growth.
            </p>
            <div className="card-underline"></div>
          </div>
        </div>

        <div 
          className={`service-card ${hoveredCard === 1 ? 'hovered' : ''}`}
          onMouseEnter={() => setHoveredCard(1)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div className="card-bg"></div>
          <div className="card-content">
            <div className="card-icon">
              <img src={mobileIcon} alt="Mobile App" className='mobile-icon'/>
            </div>
            <h3>Mobile App Development</h3>
            <p>
              Our team develops high-quality mobile apps that offer seamless user experiences
              on both Android and iOS platforms.
            </p>
            <div className="card-underline"></div>
          </div>
        </div>

        <div 
          className={`service-card ${hoveredCard === 2 ? 'hovered' : ''}`}
          onMouseEnter={() => setHoveredCard(2)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div className="card-bg"></div>
          <div className="card-content">
            <div className="card-icon">
              <img src={websiteIcon} alt="Website" className='website-icon'/>
            </div>
            <h3>Website Development</h3>
            <p>
              We create visually stunning and highly functional websites that engage visitors
              and enhance your online presence.
            </p>
            <div className="card-underline"></div>
          </div>
        </div>
      </div>

      <div className="tech-grid">
        {[...Array(30)].map((_, i) => (
          <div key={i} className="tech-cell"></div>
        ))}
      </div>
    </section>
  );
};

export default Service;